import React from "react"
import autobind from "class-autobind"
import { InfoWindow, GoogleMapLoader, GoogleMap, Marker, Circle } from "react-google-maps"
import { triggerEvent } from "react-google-maps/lib/utils"
import { IAddress } from "../../models"
import * as utils from "../../helpers/utils"
interface IGoogleMapMarker {
    position: {
        lat: number
        lng: number
    }
    showInfoWindow: boolean
    icon: string
}
interface IProps {
    address: IAddress
    geoFencePerimeter: number
    onMapClick(event): void
}
interface IState {
    marker: IGoogleMapMarker
    centerPosition: { lat: number, lng: number }
    zoom: number
}

export default class LocationMap extends React.Component<IProps, IState> {
    private googleMapComponent
    private bounds
    private defaultPosition = { lat: 38, lng: -100 }
    constructor(props) {
        super(props)
        this.state = {
            marker: this.getMapMarker(props),
            centerPosition: props.address ?
                {
                    lat: utils.getNumberFromBigNumber(props.address.Latitude),
                    lng: utils.getNumberFromBigNumber(props.address.Longitude)
                } :
                null,
            zoom: props.address ? 16 : 3
        }
        autobind(this)
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleWindowResize)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            marker: this.getMapMarker(nextProps),
            centerPosition: nextProps.address ?
                {
                    lat: utils.getNumberFromBigNumber(nextProps.address.Latitude),
                    lng: utils.getNumberFromBigNumber(nextProps.address.Longitude)
                } :
                null,
                zoom: nextProps.address ? 16 : 3
        })
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowResize)
    }

    handleWindowResize() {
        triggerEvent(this.googleMapComponent, "resize")
    }

    getMapMarker(props: IProps) {
        if (!props.address) return null
        this.bounds = new google.maps.LatLngBounds()
        const lat = utils.getNumberFromBigNumber(props.address.Latitude)
        const lng = utils.getNumberFromBigNumber(props.address.Longitude)
        const marker = {
            position: { lat, lng },
            showInfoWindow: false,
            icon: "/assets/markers/location-pin.png"
        }
        this.bounds.extend(new google.maps.LatLng(lat, lng))
        return marker
    }

    render() {
        return (
            <div
                className="LocationMap"
                style={{ width: "100%", position: "absolute", top: 0, bottom: 0, left: 0, right: 0 }}
            >
                <GoogleMapLoader
                    containerElement={<div style={{ height: "100%", width: "100%" }} />}
                    googleMapElement={
                        <GoogleMap
                            ref={item => this.googleMapComponent = item}
                            onClick={this.props.onMapClick}
                            defaultZoom={3}
                            zoom={this.state.zoom}
                            defaultCenter={this.state.centerPosition ? this.state.centerPosition : this.defaultPosition}
                            center={this.state.centerPosition ? this.state.centerPosition : this.defaultPosition}
                        >
                            {this.state.marker &&
                                <Marker
                                    {...this.state.marker}
                                    onClick={() => {
                                        this.state.marker.showInfoWindow = true
                                        this.setState({ marker: this.state.marker })
                                    }}
                                >
                                    {this.state.marker && this.state.marker.showInfoWindow &&
                                        <InfoWindow
                                            onCloseclick={() => {
                                                this.state.marker.showInfoWindow = false
                                                this.setState({ marker: this.state.marker })
                                            }}
                                        >
                                            <div>
                                                <div>{this.props.address.StreetName}</div>
                                                <div>
                                                    <strong>LAT: </strong>{this.props.address.Latitude},
                                                <strong>LNG: </strong>{this.props.address.Longitude}
                                                </div>
                                            </div>
                                        </InfoWindow>
                                    }
                                    <Circle
                                        center={this.state.centerPosition}
                                        radius={this.props.geoFencePerimeter}
                                        options={{
                                            fillColor: "#337ab7",
                                            fillOpacity: 0.2,
                                            strokeColor: "#337ab7",
                                            strokeOpacity: 1,
                                            strokeWeight: 0.8
                                        }}
                                        onClick={this.props.onMapClick}
                                    />
                                </Marker>
                            }
                        </GoogleMap>
                    }
                />
            </div>
        )
    }
}
